module.exports = __webpack_public_path__ + "img/three_th.bf94f714.png";